import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationServiceTimeResponse } from './types';

export async function getOrganizationServices(organizationId: string) {
  const url = `/web/studio/organizations/${organizationId}/services`;

  const response = await api.executeGetRequest<ListResponse<OrganizationServiceTimeResponse>>(url);

  return response;
}
